import axios from 'axios/index';
import React, {Component} from 'react';
import {Route, Switch, Redirect, NavLink, Link} from 'react-router-dom';
import toastr from 'toastr';
import {IntercomAPI} from 'react-intercom';
import * as authService from '../../services/authService';
import http from '../../services/httpService';
import EnableMessengerModal from '../modals/EnableMessengerModal';
import EnableWebpushModal from '../modals/EnableWebpushModal';
import SmsModal from '../modals/SmsModal';
import ViberModal from '../modals/ViberModal';
import ChannelsEnableBackupScreen from './ChannelsEnableBackupScreen';
import FbMessengerChannel from './distributionChannels/FbMessengerChannel';
import WebPushChannel from './distributionChannels/WebPushChannel';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'
import $ from 'jquery';
import {getCurrentUserId, getJwt} from '../../services/authService';
// import ReactGA from "react-ga";
import SmsChannel from './SmsChannel';
import ViberChannel from './ViberChanel';
import WebPushChannelDynamical from "./distributionChannels/WebPushChannelDynamical";
import {PopoverInteractionKind, Position, Popover} from "@blueprintjs/core";

const facebook_app_graph_url = process.env.REACT_APP_FB_URL;
const facebook_app_marketing_url = process.env.REACT_APP_FB_MARKETING_URL;
const facebook_app_id = process.env.REACT_APP_FACEBOOK_APP_ID;

class Channels extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: {
                facebook_pages_shared: props.facebook_pages_shared || [],
                facebook_pages:
                    {
                        data: props.facebook_pages || []
                    },
                missing_allowed_pages: []
            },
            clicked_fb: false,
            clicked_wp: false,
            fbPagesManagementPermission: false,
            fb_spinner: false,
            wp_spinner: false,
            viberCheck: '',
            smsCheck: '',
            selectedTab: 'Home',
            webpushOverlayIsOpen: false,
            webpushModalLoader: false,
            messengerOverlayIsOpen: false,
            selectedFeedShared: false,
            selectedFeedSharedData: '',
            selectedFeedSharedFbEnabled: false,
            numbers: [],
            platformsEnabled: this.props.platforms_enabled,
            selectedSource: this.props.selectSource,
            selectedSourceFull: '',
            userFull: this.props.user
        }
    }

    handleFeedMenu = () => {
        $('.feed-dropdown').fadeToggle();
    };

    componentDidMount = () => {
        let {user: userData, facebook_pages, facebook_pages_shared, platforms_enabled} = this.props;
        // ReactGA.pageview(window.location.pathname + window.location.search);

        let user = {
            ...userData,
            facebook_pages: {
                data: facebook_pages
            },
            facebook_pages_shared,
            missing_allowed_pages: []
        };

        if (window.location.pathname === '/channels') {
            this.setState({selectedTab: 'Home'})
            // this.props.history.push('/channels')
        } else if (window.location.pathname === '/channels/viber') {
            this.setState({selectedTab: 'Viber'})
            // this.props.history.push('/channels/viber')
        } else if ((window.location.pathname === '/channels/sms') || (window.location.pathname === '/channels/sms/sender-pool') ||
            (window.location.pathname === '/channels/sms/triggers') || (window.location.pathname === '/channels/sms/fine-tuning')) {
            this.setState({selectedTab: 'Sms'})
            // this.props.history.push('/channels/sms')
        } else if (window.location.pathname === '/channels/messenger') {
            this.setState({selectedTab: 'Messenger'})
            // this.props.history.push('/channels/messenger')
        } else if (window.location.pathname === '/channels/web-push') {
            this.setState({selectedTab: 'Web Push'})
            // this.props.history.push('/channels/web-push')
        }

        this.setState({
            user
        })
        let facebook_platform_enabled = platforms_enabled && platforms_enabled.indexOf("fb") > -1;
        // console.log('Permissions data: ', user.user_fb_id, user.user_fb_extended_token, user)
        if (user.user_fb_id && user.user_fb_extended_token && facebook_platform_enabled) {
            this.checkAdsManagementPermission(this.props.user.user_fb_id, this.props.user.user_fb_extended_token)
        }
        // localStorage.removeItem("viberEnableRequests")
        let viberEnableRequestsData = localStorage.getItem("viberEnableRequests");
        let smsEnableRequestsData = localStorage.getItem("smsEnableRequests");
        if (viberEnableRequestsData) {
            let dataParsed = JSON.parse(viberEnableRequestsData)
            let viberCheck = dataParsed ? dataParsed.find(source => source.toString() === this.props.selectedSource.toString()) : '';
            if ((!this.state.viberCheck && viberCheck) || (this.state.viberCheck !== viberCheck)) {
                this.setState({
                    viberCheck
                })
            }
        }
        if (smsEnableRequestsData) {
            let dataParsed = JSON.parse(smsEnableRequestsData)
            let smsCheck = dataParsed ? dataParsed.find(source => source.toString() === this.props.selectedSource.toString()) : '';
            if ((!this.state.smsCheck && smsCheck) || (this.state.smsCheck !== smsCheck)) {
                this.setState({
                    smsCheck
                })
            }
        }
        let selectedSourceFull = ''
        if (this.state.user.sources) {
            selectedSourceFull = this.state.user.sources.data.find(source => {
                return source.id === this.state.selectedSource
            })
            this.setState({
                selectedSourceFull
            })
        }

        this.getNumbers();

        this.checkActiveFeedShared();

    }

    componentDidUpdate = async () => {
        let {
            user: userData,
            facebook_pages,
            facebook_pages_shared,
            platforms_enabled
        }

            = await this.props;

        let user = await {
            ...userData,
            facebook_pages: {
                data: facebook_pages
            },
            facebook_pages_shared,
            missing_allowed_pages: []
        };

        if (this.state.selectedSource !== this.props.selectedSource) {
            let selectedSourceFull = ''
            if (this.state.user.sources) {
                selectedSourceFull = this.state.user.sources.data.find(source => {
                    return source.id === this.props.selectedSource
                })
                await this.setState({
                    selectedSourceFull
                })
            }
            await this.setState({
                selectedSourceFull,
                selectedSource: this.props.selectedSource,
                selectedTab: 'Home'
            })
        }
        if (this.state.platformsEnabled !== this.props.platforms_enabled) {
            // console.log('cdu - platforms_enabled: ', this.props.platforms_enabled)
            this.setState({
                platformsEnabled: this.props.platforms_enabled,
                viberCheck: this.props.platforms_enabled.includes('vib')
            })
        }

        if (window.location.pathname === '/channels' && this.state.selectedTab !== 'Home') {
            this.setState({selectedTab: 'Home'})
        } else if (window.location.pathname === '/channels/viber' && this.state.selectedTab !== 'Viber') {
            this.setState({selectedTab: 'Viber'})
        } else if (((window.location.pathname === '/channels/sms') || (window.location.pathname === '/channels/sms/sender-pool') ||
                (window.location.pathname === '/channels/sms/triggers') || (window.location.pathname === '/channels/sms/fine-tuning')) &&
            this.state.selectedTab !== 'Sms') {
            this.setState({selectedTab: 'Sms'})
        } else if (window.location.pathname === '/channels/messenger' && this.state.selectedTab !== 'Messenger') {
            this.setState({selectedTab: 'Messenger'})
        } else if (window.location.pathname === '/channels/web-push' && this.state.selectedTab !== 'Web Push') {
            this.setState({selectedTab: 'Web Push'})
        }

// if ((this.state.selectedTab === 'Home') && (window.location.pathname !== '/channels')) {
//     await this.props.history.push('/channels')
// } else if ((this.state.selectedTab === 'Viber') && (window.location.pathname !== '/channels/viber')) {
//     await this.props.history.push('/channels/viber')
// } else if ((this.state.selectedTab === 'Sms') && (window.location.pathname !== '/channels/sms') &&
//     (window.location.pathname !== '/channels/sms/sender-pool') && (window.location.pathname !== '/channels/sms/triggers') &&
//     (window.location.pathname !== '/channels/sms/fine-tuning')) {
//     await this.props.history.push('/channels/sms')
// } else if ((this.state.selectedTab === 'Messenger') && (window.location.pathname !== '/channels/messenger')) {
//     await this.props.history.push('/channels/messenger')
// } else if ((this.state.selectedTab === 'Web Push') && (window.location.pathname !== '/channels/web-push')) {
//     await this.props.history.push('/channels/web-push')
// }

        if (this.state.user.id !== user.id) {
            await this.setState({
                user
            })
        }
        let facebook_platform_enabled = platforms_enabled && platforms_enabled.indexOf("fb") > -1;
// console.log('Permissions data: ', user.user_fb_id, user.user_fb_extended_token, user)
        if (user.user_fb_id && user.user_fb_extended_token && facebook_platform_enabled) {
            await this.checkAdsManagementPermission(user.user_fb_id, user.user_fb_extended_token)
        }
        let viberEnableRequestsData = await localStorage.getItem("viberEnableRequests");
        let smsEnableRequestsData = await localStorage.getItem("smsEnableRequests");
        if (viberEnableRequestsData) {
            let dataParsed = await JSON.parse(viberEnableRequestsData)
            let viberCheck = await dataParsed ? dataParsed.find(source => source.toString() === this.props.selectedSource.toString()) : '';
            if ((!this.state.viberCheck && viberCheck) || (this.state.viberCheck !== viberCheck)) {
                await this.setState({
                    viberCheck
                })
            }
        }
        if (smsEnableRequestsData) {
            let smsDataParsed = await JSON.parse(smsEnableRequestsData)
            let smsCheck = await smsDataParsed ? smsDataParsed.find(source => source === this.props.selectedSource.toString()) : '';
            if ((!this.state.smsCheck && smsCheck) || (this.state.smsCheck !== smsCheck)) {
                await this.setState({
                    smsCheck
                })
            }
        }

        if (!this.state.selectedSource) {
            this.checkActiveFeedShared()
        }

    }

    checkActiveFeedShared = () => {
        let {
            //feeds_shared,
            selectedSource
        } = this.props;
        let selectedFeedShared = false;
        let selectedFeedSharedData = '';
        let selectedFeedSharedFbEnabled = false;

        if (selectedSource && !this.state.selectedSource) {
            this.setState({selectedSource: selectedSource})
        }
        // feeds_shared.map(feed => {
        //     if (feed.project_id.toString() === selectedSource.toString()) {
        //         selectedFeedShared = true;
        //         selectedFeedSharedData = feed
        //     }
        // });

        if (selectedFeedShared) {
            selectedFeedSharedData.platforms_enabled.map(platform => platform === 'fb' ? selectedFeedSharedFbEnabled = true : '')
        }

        if (selectedFeedShared) {
            this.setState({
                selectedFeedShared,
                selectedFeedSharedData,
                selectedFeedSharedFbEnabled
            })
        }

        // console.log('Cao, evo ga selectedFeedShared: ', selectedFeedShared, selectedFeedSharedData, selectedFeedSharedFbEnabled )
    }

    toggleWP = async (e) => {
        // ReactGA.event({
        //     category: 'Click',
        //     action: 'Dist platform - Enabled Webpush',
        //     userId: getCurrentUserId(),
        //     label: '',
        //     nonInteraction: true
        // });
        // console.log("PlatformsSupported toggleWP this.state.clicked_wp",this.state.clicked_wp);
        this.setState({clicked_wp: !this.state.clicked_wp, wp_spinner: true});
        await this.props.enablePlatform(e);
        // console.log(this.props.feedActiveUpdateOnChange, this.props.platforms_enabled )
        if (this.props.feedActiveUpdateOnChange && this.props.platforms_enabled && this.props.platforms_enabled.length > 0) {
            let result = await http.patch('api/feed/' + this.props.selectedSource, {active: 1}, {headers: {authorization: getJwt()}});
            this.props.updateSources(result.data);
            this.props.selectSource({id: result.data.id, source_active: true, selected_source_rss: result.data.rss})
        } else if (this.props.feedActiveUpdateOnChange && this.props.platforms_enabled.length < 1) {
            let result = await http.patch('api/feed/' + this.props.selectedSource, {active: 0}, {headers: {authorization: getJwt()}});

            this.props.updateSources(result.data);
            this.props.selectSource({id: result.data.id, source_active: false})
        }
        this.setState({wp_spinner: false})
    };

    toggleFB = async (e) => {
        //console.log("PlatformsSupported toggleFB this.state.clicked_fb",this.state.clicked_fb);
        await this.setState({clicked_fb: !this.state.clicked_fb});
        await this.props.enablePlatform(e);
        //this.props.appPropagateUserPlatforms(this.state.clicked_fb);
        if (typeof (this.props.appPropagateUserPlatforms) !== 'undefined') {
            await this.props.appPropagateUserPlatforms(this.state.clicked_fb);
        }
        if (this.props.feedActiveUpdateOnChange && this.props.platforms_enabled.length < 1) {
            let result = await http.patch('api/feed/' + this.props.selectedSource, {active: 0}, {headers: {authorization: getJwt()}});

            await this.props.updateSources(result.data);
            await this.props.selectSource({id: result.data.id, source_active: false})

        }
        //console.log('toggleFB updateUserFromServer')
        await this.props.updateUserFromServer()
        await this.checkAdsManagementPermission(this.props.user.user_fb_id, this.props.user.user_fb_extended_token)
        this.setState({selectedTab: 'Messenger'})
        // console.log('toggleFb: ', this.state.selectedTab)
    };

    checkAdsManagementPermission = async (user_fb_id, user_fb_extended_token, permissionsChangeMade) => {
        // console.log('checkAdsManagementPermission - beginning: ', user_fb_id, user_fb_extended_token, permissionsChangeMade)
        if ((!this.state.fbPagesManagementPermission || permissionsChangeMade) && user_fb_id && user_fb_extended_token) {
            try {

                // headers: { 'Access-Control-Allow-Origin': '*' } is removed from the call below to check if it is causing a bug
                const fbUserPermissions = await axios.get(facebook_app_graph_url + user_fb_id + '/permissions?access_token=' + user_fb_extended_token)
                // console.log('checkAdsManagementPermission - response: ', fbUserPermissions, fbUserPermissions.data.data.length > 0)
                if (fbUserPermissions.data.data.length > 0) {
                    // const fbPagesManagementPermission = await fbUserPermissions.data.data.find(item => item.permission === 'ads_management');
                    const fbPagesManagementPermission = await fbUserPermissions.data.data.find(item => item.permission === 'pages_show_list');
                    /* changed to 'ads_management' from from 'pages_manage_ads' */

                    if (this.state.fbPagesManagementPermission !== ((fbPagesManagementPermission.status === 'granted') ? true : false)) {
                        await this.setState({
                            fbPagesManagementPermission: (fbPagesManagementPermission.status === 'granted') ? true : false
                        })
                    }
                }
            } catch (ex) {
                if (ex.response && ex.response.status === 404)
                    this.setState({
                        errorMessage: ex.response.data.message
                    })
                if (ex.response && ex.response.status === 401) {
                    this.setState({
                        errorMessage: ex.response.data.message
                    })
                }
            }
        }
    }

    permissionsChangeMade = () => {
        let {user: userData, facebook_pages, facebook_pages_shared} = this.props;

        let user = {
            ...userData,
            facebook_pages: {
                data: facebook_pages
            },
            facebook_pages_shared,
            missing_allowed_pages: []
        };
        if (this.state.user.id !== user.id) {
            this.setState({
                user
            })
        }

        if (user.user_fb_id && user.user_fb_extended_token) {
            this.checkAdsManagementPermission(user.user_fb_id, user.user_fb_extended_token, true)
        }
    }

    responseFacebookForSourceEnable = async (response) => {
        try {
            this.setState({
                fb_spinner: true
            });
            if (response.status !== 'unknown' || (typeof (response.status) !== 'undefined')) {
                if (response.name !== "" && (typeof (response.name) !== 'undefined')) {
                    let source = "";
                    let sources = this.props.sources;
                    let selectedSource = this.props.selectedSource;
                    //let feeds_shared = this.props.feeds_shared;
                    if (sources) {
                        source = sources.filter(source =>
                            source.id.toString() === selectedSource.toString())[0];
                    }
                    // if (!source && feeds_shared) {
                    //     source = feeds_shared.filter(source =>
                    //         source.project_id.toString() === selectedSource.toString())[0];
                    // }
                    let feed_id = source.id;
                    if (feed_id === "page_source") {
                        feed_id = ""
                    }
                    let login_facebook_response = {};
                    // console.log("responseFacebook response ", response, feed_id);j
                    if (response.email && response.email !== "") {
                        try {
                            login_facebook_response = await http.post('api/login_facebook/' + feed_id, response, {headers: {authorization: getJwt()}});
                            await this.props.enablePlatform({
                                target: {
                                    id: "fb_enable",
                                    title: source.id.toString()
                                }
                            });
                            this.setState({clicked_fb: true, selectedTab: 'Messenger'});


                            // Update user
                            const data = login_facebook_response.data ? login_facebook_response.data.data : "";
                            const missing_allowed_pages = login_facebook_response.data.missing_allowed_pages.filter(page => page.connected)
                            if (data) {
                                this.setState({
                                    user: Object.assign(
                                        {},
                                        this.state.user,
                                        {
                                            facebook_pages: data.facebook_pages,
                                            facebook_pages_shared: data.facebook_pages_shared,
                                            missing_allowed_pages
                                        }
                                    )
                                });
                                await this.props.updateUser({
                                    facebook_pages: data.facebook_pages,
                                    facebook_pages_shared: data.facebook_pages_shared,
                                    missing_allowed_pages
                                })
                            }
                            /* Updating platforms_enabled */
                            if (this.props.feedActiveUpdateOnChange && this.props.platforms_enabled && this.props.platforms_enabled.length > 0) {

                                let result = await http.patch('api/feed/' + this.props.selectedSource, {active: 1}, {headers: {authorization: getJwt()}});
                                let platformsEnabled = await result.data.platforms_enabled

                                this.props.updateSources(result.data);
                                this.props.selectSource({
                                    id: result.data.id,
                                    source_active: true,
                                    selected_source_rss: result.data.rss
                                })
                            }
                        } catch (e) {
                            toastr.error("Facebook channel enabling was unsuccessful, please try later.")
                        }

                    } else {
                        toastr.error("Email obtain permission has to be checked in order to register!")
                    }
                }
                this.setState({
                    fb_spinner: false
                });
            } else {
                toastr.error("Facebook response undefined! Please try later, or,  try standard register approach instead.")
            }
        } catch (ex) {
            this.setState({
                fb_spinner: false
            });
        }
        // console.log('responseFacebookForSourceEnable updateUserFromServer')
        await this.props.updateUserFromServer()
    };

    viberModalOpen = () => {

        window.open('https://emitto.io/viber-new-sender-name/')


        // if(!this.state.overlayIsOpen){
        //     this.setState({
        //         overlayIsOpen: true
        //     })
        // }
    }

    viberModalClose = () => {
        this.setState({
            overlayIsOpen: false
        })
    }

    setViberCheck = (data) => {
        this.setState({
            viberCheck: data
        })
    }

    smsModalOpen = () => {
        this.setState({
            smsOverlayIsOpen: true
        })
    }

    smsModalClose = () => {
        this.setState({
            smsOverlayIsOpen: false
        })
    }

    setSmsCheck = (data) => {
        this.setState({
            smsCheck: data
        })
    }

    webpushModalOpen = () => {
        if (!this.state.webpushOverlayIsOpen) {
            this.setState({
                webpushOverlayIsOpen: true
            })
        }
    }

    webpushModalClose = () => {
        this.setState({
            webpushOverlayIsOpen: false
        })
    }

    messengerModalOpen = () => {
        if (!this.state.messengerOverlayIsOpen) {
            this.setState({
                messengerOverlayIsOpen: true
            })
        }
    }
    disabledChannelClick = (e) => {
        e.preventDefault()
    }
    messengerModalClose = () => {
        this.setState({
            messengerOverlayIsOpen: false
        })
    }

    handleWebpushEnable = async () => {
        await this.setState({webpushModalLoader: true})
        await this.toggleWP({target: {title: this.props.selectedSource, id: 'wp_enable'}})
        await this.setState({webpushModalLoader: false, selectedTab: 'Web Push', webpushOverlayIsOpen: false})
    }

    getNumbers = async () => {
        let projectId = await this.props.selectedSource ? this.props.selectedSource : localStorage.source_clicked ? JSON.parse(localStorage.source_clicked) : '';
        let user = await this.props.user;
        if (user && user.id && projectId) {
            try {
                const result = await http.get('/api/user/' + user.id + '/project/' + projectId + '/project_phones', {headers: {authorization: getJwt()}});

                await this.setState({
                    numbers: result.data.project_phones,
                })
            } catch (ex) {
                if (ex.response && ex.response.status === 404)
                    // toastr.error("Something went wrong... Please refresh and try again.");
                    this.setState({loader: false, posts: '', rowHeights: []})
                if (ex.response && ex.response.status === 401) {
                    toastr.error(ex.response.data.message);
                    this.props.history.push('/logout');
                }
            }
        }

    }

    render() {
        const {
            sources, activateFeed,
            //feeds_shared,
            selectedSource, onClick, openModal, updateUser, user_facebook_pages,
            enablePlatform, updateSources, selectSource, selected_source, selectedSourceNode
        } = this.props;
        let {
            user: userData, sourceId, facebook_pages, platforms_enabled, facebook_pages_shared, user_fb_id,
            user_fb_extended_token
        } = this.props;
        let facebook_platform_enabled = platforms_enabled && platforms_enabled.indexOf("fb") > -1;
        let webpush_platform_enabled = platforms_enabled && platforms_enabled.indexOf("wp") > -1;

        let platform_limits_fb_enabled = this.props.selectedSourceNode && this.props.selectedSourceNode.plan &&
            this.props.selectedSourceNode.plan.platform_limits && this.props.selectedSourceNode.plan.platform_limits.fb ?
            this.props.selectedSourceNode.plan.platform_limits.fb.enabled : 0;

        let platform_limits_wp_enabled = this.props.selectedSourceNode && this.props.selectedSourceNode.plan &&
        this.props.selectedSourceNode.plan.platform_limits && this.props.selectedSourceNode.plan.platform_limits.wp ?
            this.props.selectedSourceNode.plan.platform_limits.wp.enabled : 0;

        let platform_limits_vib_enabled = this.props.selectedSourceNode && this.props.selectedSourceNode.plan &&
        this.props.selectedSourceNode.plan.platform_limits && this.props.selectedSourceNode.plan.platform_limits.vib ?
            this.props.selectedSourceNode.plan.platform_limits.vib.enabled : 0;

        $('.bkg-img').css('position', 'absolute');
        //let source, onlypage = "";
        let source = "";

        if (sources) {
            source = sources.filter(source =>
                source.id.toString() === selectedSource.toString())[0];
        }
        //console.log('channel source 1: ', source)
        //console.log('channels feeds shared: ', feeds_shared)
        //console.log('channels selectedSource: ', selectedSource)

        // if (!source && feeds_shared) {
        //     //console.log('selected source is shared')
        //     source = feeds_shared.filter(source => {
        //             return source.project_id && source.project_id.toString() === selectedSource.toString()
        //         }
        //     )
        //     source = source[0]
        //
        // }

        //console.log('channel source: 1', source);

        if (!selectedSource) {
            return <React.Fragment>
                <div className="display-flex">
                    <h1 className='main-title'>Channels</h1>
                </div>

                <div className="row">
                    <div className="col-xs-12 text-center no-feeds-containers">
                        <div className="feed-msg">
                            <img className='emitto-mark' src="/img/emitto-mark.png" alt="Emitto Mark"/>
                            <p className="text-center ">{authService.getCurrentUserName()}</p>
                            <p>It looks like you haven't set up any workspaces yet. Add your first workspace, and start
                                growing
                                your audience.</p>
                            <img className='cat-img' src="/img/cat-transparent.gif" alt="No Workspaces"/>
                        </div>
                        <button className='btn-m btn-action' onClick={this.props.addSource} type="button">
                            Create your first workspace
                        </button>
                    </div>
                </div>
            </React.Fragment>
        }
        return <div style={{backgroundColor: '#F7F7F7'}}>
            <h1 className='main-title'>Channels</h1>
            <div className="supported-channels-container">
                {this.props.selectedSourceNode ?
                    <div className="tabs-navigation">
                        <div
                            onClick={() => this.props.history.push('/channels')}
                            className={this.state.selectedTab === 'Home' ? "navigation-tab active" : "navigation-tab"}>
                            <p><i className="fas fa-home"></i></p>
                        </div>
                        {/*<div*/}
                        {/*onClick={ () => this.setState({selectedTab: 'FB Ads'})}*/}
                        {/*className={ this.state.selectedTab === 'FB Ads' ? "navigation-tab active" : "navigation-tab"}>*/}
                        {/*<p><i style={{color: '#4278BE'}} className="fab fa-facebook-f"></i>Facebook ADS</p>*/}
                        {/*</div>*/}
                        <div
                            onClick={() => this.props.history.push('/channels/sms')}
                            className={this.state.selectedTab === 'Sms' ? "navigation-tab active" : "navigation-tab"}>
                            <img src='/img/channels/sms-icon.svg'/><p>SMS</p>
                        </div>
                        <div
                            onClick={() => this.props.history.push('/channels/viber')}
                            className={this.state.selectedTab === 'Viber' ? "navigation-tab active" : "navigation-tab"}>
                            <p>
                                {this.state.platformsEnabled !== [] ?
                                    this.state.platformsEnabled.includes('vib') ?
                                        <React.Fragment>
                                            <img src='/img/channels/viber-icon.svg'/>
                                        </React.Fragment>
                                        :
                                        <React.Fragment>
                                            <img src='/img/channels/viber-icon-1.svg'/>
                                        </React.Fragment>
                                    :
                                    <React.Fragment>
                                        <img src='/img/channels/viber-icon-1.svg'/>
                                    </React.Fragment>
                                }

                                Viber</p>
                        </div>
                        <div
                            onClick={() => this.props.history.push('/channels/web-push')}
                            className={this.state.selectedTab === 'Web Push' ? "navigation-tab active" : "navigation-tab"}>
                            {(sources.length
                                //    || feeds_shared.length
                            ) && webpush_platform_enabled ?
                                <img src='/img/channels/notification-icon.svg'/> : ''}
                            <p>{(sources.length
                                //  || feeds_shared.length
                            ) && webpush_platform_enabled ? '' :
                                <img src='/img/channels/notification-icon-1.svg'/>}Web Push</p>
                        </div>
                        {platform_limits_fb_enabled === 1 ?
                            <div
                                onClick={() => this.props.history.push('/channels/messenger')}
                                className={this.state.selectedTab === 'Messenger' ? "navigation-tab active" : "navigation-tab"}>
                                {((sources.length
                                    //    || feeds_shared.length
                                ) && facebook_platform_enabled && this.state.fbPagesManagementPermission) || (this.state.selectedFeedSharedFbEnabled && facebook_platform_enabled) ?
                                    <img src='/img/channels/messenger-icon.svg'/> : ''}
                                <p>
                                    {((sources.length
                                        //    || feeds_shared.length
                                    ) && facebook_platform_enabled && this.state.fbPagesManagementPermission) || (this.state.selectedFeedSharedFbEnabled && facebook_platform_enabled) ?
                                        ''
                                        :
                                        <img src='/img/channels/messenger-icon-1.svg'/>
                                    }Messenger</p>
                            </div>
                            :
                            <Popover
                                interactionKind={PopoverInteractionKind.CLICK}

                                position={Position.TOP}
                                minimal={true}
                            >

                                <div
                                    className={this.state.selectedTab === 'Messenger' ? "navigation-tab active" : "navigation-tab"}>
                                    {((sources.length
                                        //    || feeds_shared.length
                                    ) && facebook_platform_enabled && this.state.fbPagesManagementPermission) || (this.state.selectedFeedSharedFbEnabled && facebook_platform_enabled) ?
                                        <img src='/img/channels/messenger-icon.svg'/> : ''}
                                    <p>
                                        {((sources.length
                                            //    || feeds_shared.length
                                        ) && facebook_platform_enabled && this.state.fbPagesManagementPermission) || (this.state.selectedFeedSharedFbEnabled && facebook_platform_enabled) ?
                                            ''
                                            :
                                            <img src='/img/channels/messenger-icon-1.svg'/>
                                        }Messenger</p>
                                </div>
                                <div className='popover-content unavailable-channel-popover'>
                                    Messenger channel is not available on this plan!
                                    Please <Link to='/subscription-plans'>upgrade plan</Link> to unlock this
                                    channel.
                                </div>
                            </Popover>
                        }
                    </div>
                    : ''}
                {/*{ this.state.selectedTab === 'Home' ? '' :*/}
                {/*href={ this.state.selectedTab === 'Sms' ? 'https://app.emitto.io/channels/sms?product_tour_id=183407' :*/}
                {/*this.state.selectedTab === 'Messenger' ? 'https://app.emitto.io/channels/messenger?product_tour_id=183434' :*/}
                {/*this.state.selectedTab === 'Web Push' ? 'https://app.emitto.io/channels/web-push?product_tour_id=183425' : '' }>Start Guided Tour</a>*/}
                {/*}*/}
            </div>
            {this.state.selectedTab === 'Home' && (window.location.pathname === '/channels') ?
                <div className='home-channels-container'>
                    <h3>Enabled Channels</h3>
                    <div className='channels-container'>
                        <div className='single-channel' onClick={() => this.props.history.push('/channels/sms')}>
                            {/*<i style={{color: '#17AA94'}} className="far fa-comment-dots"></i>*/}
                            <img src="img/channels/sms-icon.svg" style={{marginRight: 20}}/>
                            <div className='channel-text'>
                                <h3>SMS</h3>
                                <p>Settings</p>
                            </div>
                            {this.state.numbers && this.state.numbers.length ?
                                ''
                                :
                                <div className='float-notification'>
                                    <p>No Active Number</p>
                                </div>
                            }
                        </div>

                        {this.state.platformsEnabled.includes('vib') ?

                            <div className='single-channel'
                                 onClick={() => this.props.history.push('/channels/viber')}
                            >
                                {/*<i style={{color: '#665cac'}} className="fab fa-viber"></i>*/}
                                <img src="img/channels/viber-icon.svg"/>
                                <div className='channel-text'>
                                    <h3>Viber</h3>

                                    <p>Settings</p>

                                </div>
                                {/*<ViberModal*/}
                                {/*    showModal={this.state.overlayIsOpen}*/}
                                {/*    handleClose={this.viberModalClose}*/}
                                {/*    selectedSource={selectedSource}*/}
                                {/*    sources={this.props.sources}*/}
                                {/*    feedsShared={feeds_shared}*/}
                                {/*    setViberCheck={this.setViberCheck}*/}
                                {/*    maxWidth={500}*/}
                                {/*/>*/}
                            </div>

                            : ''}
                        {/*<div className='single-channel'>*/}
                        {/*<i style={{color: '#4278BE'}} className="fab fa-facebook-f"></i>*/}
                        {/*<div className='channel-text'>*/}
                        {/*<h3>Facebook</h3>*/}
                        {/*<p>Settings</p>*/}
                        {/*</div>*/}
                        {/*</div>*/}
                        {((sources.length
                            //    || feeds_shared.length
                        ) && facebook_platform_enabled && this.state.fbPagesManagementPermission) || (this.state.selectedFeedSharedFbEnabled && facebook_platform_enabled) ?
                            <div className='single-channel'
                                 onClick={() => this.props.history.push('/channels/messenger')}>
                                {/*<i className="fab fa-facebook-messenger"></i>*/}
                                <img src="img/channels/messenger-icon.svg"/>
                                <div className='channel-text'>
                                    <h3>Messenger</h3>
                                    <p>Settings</p>
                                </div>
                            </div>
                            :
                            ''
                        }
                        {/*<div className='single-channel'>*/}
                        {/*<i style={{color: '#665cac'}} className="fab fa-viber"></i>*/}
                        {/*<div className='channel-text'>*/}
                        {/*<h3>Viber</h3>*/}
                        {/*<p>Settings</p>*/}
                        {/*</div>*/}
                        {/*</div>*/}
                        {(sources.length
                            //    || feeds_shared.length
                        ) && webpush_platform_enabled ?
                            <div className='single-channel'
                                 onClick={() => this.props.history.push('/channels/web-push')}>
                                {/*<i className="fas fa-bell" style={{color: '#F49F2C'}}/>*/}
                                <img src="img/channels/notification-icon.svg"/>
                                <div className='channel-text'>
                                    <h3>Web Push</h3>
                                    <p>Settings</p>
                                </div>
                            </div>
                            :
                            ''
                        }
                    </div>

                    {
                        //if all channels are enabled,
                        this.state.platformsEnabled.length < 5 ?
                            <React.Fragment>
                                <h3>All Channels</h3>
                                {this.props.selectedSourceNode ?
                                    <div className='channels-container'>

                                        {((sources.length
                                            //    || feeds_shared.length
                                        ) && facebook_platform_enabled && this.state.fbPagesManagementPermission) || (this.state.selectedFeedSharedFbEnabled && facebook_platform_enabled) ?
                                            ''
                                            :
                                            platform_limits_fb_enabled === 0 ?
                                                <Popover
                                                    interactionKind={PopoverInteractionKind.CLICK}

                                                    position={Position.TOP}
                                                    minimal={true}
                                                >

                                                    <div
                                                        className={`single-channel ${platform_limits_fb_enabled === 0 ? 'channel-disabled' : ''}`}

                                                        onClick={
                                                            platform_limits_fb_enabled === 1 ?

                                                                () => this.props.history.push('/channels/messenger')
                                                                : (e) => this.disabledChannelClick(e)
                                                        }>
                                                        {/*<i className="fab fa-facebook-messenger"></i>*/}
                                                        <img src="/img/channels/messenger-icon.svg"/>
                                                        <div className='channel-text'>
                                                            <h3>Messenger</h3>
                                                            <p>Setup in 5 minutes.</p>
                                                        </div>
                                                        <div className="float-notification-unavailable"><p
                                                            className='all-caps'>Unavailable</p></div>

                                                    </div>
                                                    <div className='popover-content unavailable-channel-popover'>
                                                        Messenger channel is not available on this plan!
                                                        Please <Link to='/subscription-plans'>upgrade plan</Link> to
                                                        unlock this channel.
                                                    </div>
                                                </Popover>
                                                :
                                                <div
                                                    className={`single-channel ${platform_limits_fb_enabled === 0 ? 'channel-disabled' : ''}`}

                                                    onClick={
                                                        platform_limits_fb_enabled === 1 ?
                                                            () => this.props.history.push('/channels/messenger')
                                                            : (e) => this.disabledChannelClick(e)
                                                    }>
                                                    {/*<i className="fab fa-facebook-messenger"></i>*/}
                                                    <img src="/img/channels/messenger-icon.svg"/>
                                                    <div className='channel-text'>
                                                        <h3>Messenger</h3>
                                                        <p>Setup in 5 minutes.</p>
                                                    </div>
                                                    <div className="float-notification-unavailable"><p
                                                        className='all-caps'>Unavailable</p></div>

                                                </div>
                                            // <FacebookLogin
                                            //     appId={facebook_app_id}
                                            //     autoLoad={false}
                                            //     return_scopes={true}
                                            //     fields="name, email, picture"
                                            //     scope="email, public_profile, pages_messaging, pages_read_engagement"
                                            //     callback={this.responseFacebookForSourceEnable}
                                            //     render={renderProps => (
                                            //         <div className='single-channel' onClick={renderProps.onClick}>
                                            //             {/*<i className="fab fa-facebook-messenger"></i>*/}
                                            //             <img src="img/channels/messenger-icon.svg"
                                            //                  style={{width: 35, height: 35, marginRight: 20}}/>
                                            //             <div className='channel-text'>
                                            //                 <h3>Facebook</h3>
                                            //                 <p>Setup in 5 minutes.</p>
                                            //             </div>
                                            //         </div>
                                            //     )}
                                            // />
                                        }
                                        {!this.state.platformsEnabled.includes('vib') ?
                                            <div
                                                className={`single-channel ${platform_limits_vib_enabled === 0 ? 'channel-disabled' : ''}`}
                                                onClick={
                                                    platform_limits_vib_enabled === 1 ?
                                                        () => this.props.history.push('/channels/viber')
                                                        : (e) => this.disabledChannelClick(e)
                                                }>
                                                {/*<i style={{color: '#665cac'}} className="fab fa-viber"></i>*/}
                                                <img src="img/channels/viber-icon.svg"/>
                                                <div className='channel-text'>
                                                    <h3>Viber</h3>
                                                    {this.state.viberCheck || (selectedSourceNode && selectedSourceNode.viber_client &&
                                                        selectedSourceNode.viber_client.apply_status &&
                                                        selectedSourceNode.viber_client.apply_status === 'requested') ?
                                                        <p>Settings</p>
                                                        :
                                                        <p id="wp_enable" title={selectedSource}>Request Access</p>
                                                    }
                                                    {
                                                        selectedSourceNode && selectedSourceNode.viber_client &&
                                                        selectedSourceNode.viber_client.apply_status &&
                                                        selectedSourceNode.viber_client.apply_status === 'requested' ?
                                                        <span className='float-top-right required-label'>Requested</span>
                                                        :
                                                        ''
                                                    }

                                                    <div className="float-notification-unavailable"><p
                                                        className='all-caps'>Unavailable</p></div>

                                                </div>
                                                {/*<ViberModal*/}
                                                {/*    showModal={this.state.overlayIsOpen}*/}
                                                {/*    handleClose={this.viberModalClose}*/}
                                                {/*    selectedSource={selectedSource}*/}
                                                {/*    sources={this.props.sources}*/}
                                                {/*    feedsShared={feeds_shared}*/}
                                                {/*    setViberCheck={this.setViberCheck}*/}
                                                {/*    maxWidth={500}*/}
                                                {/*/>*/}
                                            </div> :
                                            ''
                                        }
                                        {(sources.length) && webpush_platform_enabled ?
                                            ''
                                            :
                                            <div
                                                className={`single-channel ${platform_limits_wp_enabled === 0 ? 'channel-disabled' : ''}`}
                                                onClick={
                                                    platform_limits_wp_enabled === 1 ?
                                                        () => this.props.history.push('/channels/web-push')
                                                        : (e) => this.disabledChannelClick(e)
                                                }>

                                                {/*<i className="fas fa-bell" style={{color: '#F49F2C'}}/>*/}
                                                <img src="img/channels/notification-icon.svg"
                                                     alt='notification icon'/>
                                                <div className='channel-text'>
                                                    <h3>Web Push</h3>
                                                    <p>Setup in 5 minutes.</p>
                                                </div>
                                                <div className="float-notification-unavailable"><p
                                                    className='all-caps'>Unavailable</p></div>

                                            </div>
                                        }
                                        {/*<div className='single-channel'>*/}
                                        {/*<i style={{color: '#17AA94'}} className="far fa-comment-dots"></i>*/}
                                        {/*<div className='channel-text'>*/}
                                        {/*<h3>SMS</h3>*/}
                                        {/*<p>Setup in 15 minutes.</p>*/}
                                        {/*</div>*/}
                                        {/*</div>*/}

                                    </div>
                                    : ''}
                            </React.Fragment>
                            : ''
                    }
                </div>
                :
                ''
            }
            {this.state.selectedTab === 'FB Ads' ?
                <div className="channel-container">
                    <h3>Facebook Ads</h3>
                    <div className='grey-container'>
                        <p className='green'>Active</p>
                    </div>
                </div>
                :
                ''
            }
            {/*Router starts*/}
            <Switch>
                <Route path="/channels/sms"
                       render={(props) => <SmsChannel
                           sources={this.props.sources}
                           // feeds_shared={this.props.feeds_shared}
                           selectedSource={this.props.selectedSource}
                           selectedSourceNode={this.props.selectedSourceNode}
                           user={this.props.user}
                           updateUser={this.props.updateUser}
                           updateSources={this.props.updateSources}
                           selectSource={this.props.selectSource}
                           updateUserFromServer={this.props.updateUserFromServer}
                           history={this.props.history}
                           tags={this.props.tags}
                           handleCreateTag={this.props.handleCreateTag}
                           handleGetTags={this.props.handleGetTags}
                       />
                       }
                />
                <Route path="/channels/viber"
                       render={(props) =>
                           // selectedSourceNode.viber_client !== null ?
                           //     selectedSourceNode.viber_client && selectedSourceNode.viber_client.apply_status &&
                           //     ((selectedSourceNode.viber_client.apply_status === 'requested') ||
                           //         (selectedSourceNode.viber_client.apply_status === 'active')) ?

                                   <ViberChannel
                                       sources={this.props.sources}
                                       feeds_shared={this.props.feeds_shared}
                                       selectedSource={this.props.selectedSource}
                                       selectedSourceNode={this.props.selectedSourceNode}
                                       user={this.props.user}
                                       updateUser={this.props.updateUser}
                                       updateSources={this.props.updateSources}
                                       selectSource={this.props.selectSource}
                                       updateUserFromServer={this.props.updateUserFromServer}
                                       history={this.props.history}
                                   />
                       //             :
                       //
                       //             <div className="channel-container">
                       //                 <ChannelsEnableBackupScreen
                       //                     type='viber'
                       //                     text='Viber Business Profile is not registered or activated.'
                       //                     buttonElement={<button className='btn-action' title={selectedSource}
                       //                                            onClick={this.viberModalOpen}>
                       //                         Request Viber Business Profile
                       //                     </button>
                       //                     }
                       //                 />
                       //             </div>
                       //         :
                       //
                       //         <div className="channel-container">
                       //             <ChannelsEnableBackupScreen
                       //                 type='viber'
                       //                 text='Viber Business Profile is not registered or activated.'
                       //                 buttonElement={<button className='btn-action' title={selectedSource}
                       //                                        onClick={this.viberModalOpen}>
                       //                     Request Viber Business Profile
                       //                 </button>
                       //                 }
                       //             />
                       //         </div>
                       }

                />
                <Route path="/channels/messenger"
                       render={(props) => <div className="channel-container">
                           {/*<h3>Messenger</h3>*/}
                           {/*<div className='grey-container'>*/}
                           {(sources.length
                               && facebook_platform_enabled && this.state.fbPagesManagementPermission) ||
                           (this.state.selectedFeedSharedFbEnabled && facebook_platform_enabled) ?
                               <FbMessengerChannel
                                   user={this.state.user}
                                   count_pages={this.props.count_pages}
                                   sourceId={selectedSource}
                                   source_rss={source && source.rss ? source.rss : ''}
                                   platforms_enabled={platforms_enabled}
                                   onClick={onClick}
                                   activateFeed={activateFeed}
                                   facebook_pages={user_facebook_pages}
                                   facebook_pages_shared={facebook_pages_shared}
                                   openModal={openModal}
                                   onlypage={source && source.onlypage ? source.onlypage : ''}
                                   web_push_id={source && source.web_push_id ? source.web_push_id : ''}
                                   appPropagateUserData={this.props.appPropagateUserData}
                                   website={source && source.website ? source.website : ''}
                                   enablePlatform={enablePlatform}
                                   updateUser={this.props.updateUserFromServer}
                                   updateSources={updateSources}
                                   selectSource={selectSource}
                                   feedActiveUpdateOnChange={true}
                                   permissionsChangeMade={this.permissionsChangeMade}
                                   toggleConnect={onClick}
                               />
                               :
                               <ChannelsEnableBackupScreen
                                   type='messenger'
                                   text='Connect a Facebook Page in order to start your first campaign.'
                                   buttonElement={
                                       this.state.fb_spinner ?
                                           <button className='btn-action spinner' disabled={true}>
                                               Connect a Facebook Page <i className='fa fa-spin fa-spinner'/>
                                           </button>
                                           :
                                           <FacebookLogin
                                               appId={facebook_app_id}
                                               autoLoad={false}
                                               return_scopes={true}
                                               fields="name, email, picture"
                                               scope="email, public_profile, pages_messaging, pages_read_engagement"
                                               callback={this.responseFacebookForSourceEnable}
                                               render={renderProps => (
                                                   <button onClick={renderProps.onClick} className="btn-action">
                                                       <p>Connect a Facebook Page</p>
                                                   </button>
                                               )}
                                           />
                                   }
                               />
                           }
                           {/*</div>*/}
                       </div>
                       }/>
                <Route path="/channels/web-push"
                       render={(props) => <div className="channel-container">
                           {/*<h3>Web Push</h3>*/}
                           <div className="enabled-channels-container">
                               {/*{console.log('channel source 2: ', source)}*/}
                               {sources.length
                               && webpush_platform_enabled ?
                               //     process.env.REACT_APP_ENVIRONMENT === 'DEV' ?
                                       <WebPushChannelDynamical
                                           user={this.props.user}
                                           count_pages={this.props.count_pages}
                                           sourceId={source.id}
                                           source_rss={source.rss}
                                           platforms_enabled={platforms_enabled}
                                           onClick={onClick}
                                           activateFeed={activateFeed}
                                           facebook_pages={user_facebook_pages}
                                           facebook_pages_shared={facebook_pages_shared}
                                           openModal={openModal}
                                           onlypage={source.onlypage}
                                           web_push_id={source.web_push_id}
                                           appPropagateUserData={this.props.appPropagateUserData}
                                           website={source.website}
                                           enablePlatform={enablePlatform}
                                           updateUser={updateUser}
                                           updateSources={updateSources}
                                           selectSource={selectSource}
                                           feedActiveUpdateOnChange={true}
                                       />
                                       // :
                                       // <WebPushChannel
                                       //     user={this.props.user}
                                       //     count_pages={this.props.count_pages}
                                       //     sourceId={source.id}
                                       //     source_rss={source.rss}
                                       //     platforms_enabled={platforms_enabled}
                                       //     onClick={onClick}
                                       //     activateFeed={activateFeed}
                                       //     facebook_pages={user_facebook_pages}
                                       //     facebook_pages_shared={facebook_pages_shared}
                                       //     openModal={openModal}
                                       //     onlypage={source.onlypage}
                                       //     web_push_id={source.web_push_id}
                                       //     appPropagateUserData={this.props.appPropagateUserData}
                                       //     website={source.website}
                                       //     enablePlatform={enablePlatform}
                                       //     updateUser={updateUser}
                                       //     updateSources={updateSources}
                                       //     selectSource={selectSource}
                                       //     feedActiveUpdateOnChange={true}
                                       // />

                                   :
                                   <ChannelsEnableBackupScreen
                                       type='webpush'
                                       text='Web Push is not enabled.'
                                       buttonElement={
                                           this.state.wp_spinner ?
                                               <button className='btn-action spinner' disabled={true}>
                                                   Enable Web Push <i className='fa fa-spin fa-spinner'/>
                                               </button>
                                               :
                                               <button className='btn-action' title={selectedSource} id="wp_enable"
                                                       onClick={this.toggleWP}>
                                                   Enable Web Push
                                               </button>
                                       }
                                   />
                               }
                           </div>
                       </div>
                       }/>
            </Switch>

            <EnableMessengerModal
                showModal={this.state.messengerOverlayIsOpen}
                handleClose={this.messengerModalClose}
                handleFinish={() => this.setState({selectedTab: 'Messenger'})}
                selectedSource={selectedSource}
                sources={this.props.sources}
                //feedsShared={feeds_shared}
                handleEnable={this.handleMessengerEnable}
                loaderActive={this.state.fb_spinner}
                maxWidth={500}
                userFullName=''
                //feeds_shared={feeds_shared}
                user={this.props.user}
                onClick={this.props.toggleConnect}
                user_facebook_pages={user_facebook_pages}
                facebook_pages_shared={facebook_pages_shared}
                enablePlatform={enablePlatform}
                platforms_enabled={platforms_enabled}
                appPropagateUserData={this.props.appPropagateUserData}
                updateUser={this.props.updateUserFromServer}
                updateSources={updateSources}
                selectSource={selectSource}
            />

            <EnableWebpushModal
                showModal={this.state.webpushOverlayIsOpen}
                handleClose={() => this.webpushModalClose()}
                selectedSource={selectedSource}
                sources={this.props.sources}
                //feedsShared={feeds_shared}
                handleEnable={this.handleWebpushEnable}
                loaderActive={this.state.webpushModalLoader}
                maxWidth={500}
            />
        </div>
    }
}


export default Channels;